export const getMinPriceParam = (
    priceMinMonthly = '0',
    priceMinWeekly = '0',
    priceMin = '0'
) => {
    if (priceMinMonthly !== '0' && priceMinMonthly !== '') {
        return priceMinMonthly;
    }

    if (priceMinWeekly !== '0' && priceMinWeekly !== '') {
        return priceMinWeekly;
    }

    return priceMin !== '0' && priceMin !== '' ? priceMin : '';
};
